































































































import { State, Action, Getter } from 'vuex-class';
import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {
    PagePresetDashboard: () => import('@/layouts/presets/dashboard.vue'),
    PartBox: () => import('@/layouts/parts/box.vue'),
    PartOverlay: () => import('@/layouts/parts/overlay.vue'),
    // Form elements
    FormBase: () => import('@/components/forms/Base.vue'),
    FormInput: () => import('@/components/forms/Input.vue'),
    FormButton: () => import('@/components/forms/Button.vue'),
    FormCheckbox: () => import('@/components/forms/Checkbox.vue'),
    ServerError: () => import('@/components/forms/ServerError.vue'),
  },
})
export default class PageResellersShow extends Vue {
  i18n: string = 'views.resellers.show';

  @Action('reseller/create') createReseller!: (payload: Reseller) => Promise<Reseller>;

  @Action('reseller/update') updateReseller!: (payload: Reseller) => Promise<Reseller>;

  @Action('reseller/delete') deleteReseller!: (payload: { id: number }) => Promise<Reseller>;

  @Getter('reseller/viewing') reseller!: Reseller;

  @Action('account/index') readAccounts!: () => Promise<PimAccount>;

  @Action('account/patch') patchAccount!: ({ id, data }: { id: number; data: Partial<PimAccountData> }) => Promise<PimAccount>;

  @Getter('account/all') accounts!: PimAccount[];

  $refs!: Vue['$refs'] & {
    resellerForm: FormClass;
    deleteForm: FormClass;
  };

  formLoaded: boolean = false;

  payload: Reseller = {
    name: '',
    min_order_amount: 0,
    discount_percentage: 0,
    pay_by_invoice: false,
  };

  resellerAccounts: number[] = [];

  popupDeleteReseller: boolean = false;

  async mounted() {
    await this.readAccounts();
    // @ts-ignore
    this.localAccounts = structuredClone(this.accounts);
    if (this.reseller) {
      this.resellerAccounts = this.accounts.filter((account) => account.reseller_id === this.reseller.id).map((account) => account.id!);
    }
  }

  get accountsToUpdate(): Array<{ id: number; is_reseller: boolean }> {
    const payloads: Array<{ id: number; is_reseller: boolean }> = [];
    this.accounts.forEach((account) => {
      if (account.reseller_id === this.reseller?.id && this.resellerAccounts.includes(account.id!)) {
        return;
      }
      if (account.reseller_id === null && !this.resellerAccounts.includes(account.id!)) {
        return;
      }

      if (this.resellerAccounts.includes(account.id!)) {
        payloads.push({ id: account.id!, is_reseller: true });
        return;
      }
      payloads.push({ id: account.id!, is_reseller: false });
    });

    return payloads;
  }

  private handleSubmit() {
    let func: string = 'updateReseller';
    if (!this.payload.id) {
      func = 'createReseller';
    }

    const payload: Reseller = {
      id: this.payload.id,
      name: this.payload.name,
      min_order_amount: parseInt(this.payload.min_order_amount + '', 10),
      discount_percentage: this.payload.discount_percentage / 100,
      pay_by_invoice: this.payload.pay_by_invoice,
    };

    // @ts-ignore
    this[func](payload)
      .then((reseller: Reseller) => {
        const accountPromises = this.accountsToUpdate.map((atu) => this.patchAccount({ id: atu.id, data: { reseller_id: atu.is_reseller ? reseller.id : null } }));
        Promise.all(accountPromises).then(() => {
          this.$refs.resellerForm.handleSuccess();
          if (func === 'createReseller' && reseller.id) {
            this.$router.push({ name: 'resellers-detail', params: { id: `${reseller.id}` } });
          }
        });
      })
      .catch((e: ErrorResponse) => this.$refs.resellerForm.handleErrors(e));
  }

  private handleDelete() {
    if (this.payload.id) {
      this.deleteReseller({ id: this.payload.id })
        .then(() => {
          this.$refs.deleteForm.handleSuccess();
          this.popupDeleteReseller = false;
          this.$router.push({ name: 'resellers' });
        })
        .catch((e: ErrorResponse) => this.$refs.deleteForm.handleErrors(e));
    }
  }

  @Watch('reseller', { immediate: true, deep: true })
  private handleResellerChanged(val: Reseller) {
    if (!val) {
      return undefined;
    }

    this.payload = JSON.parse(JSON.stringify(val));
    this.payload.discount_percentage = Math.round(this.payload.discount_percentage * 100);
  }
}
